//
// LogarithmicAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./NumericAxisOptions";
import "./LogarithmBase";
import "./LogarithmTickmarkIntervalStyle";
import "./AxisTickValueFormatOptions";
import "./LogarithmValuesType";

var LogarithmicAxisOptions = createModule("gtl::LogarithmicAxisOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::NumericAxisOptions"], EventDispatcher, [
    ,
    {
        logBase: 4,
        tickValueFormat: 1,
        valuesType: 4,
        tickmarkIntervalStyle: 4,
        minorTickCount: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LogarithmicAxisOptions;
